// ========================================
// ================== V3 ==================
// ========================================

import { put } from "redux-saga/effects";
import axios from "../../axios";
import * as actions from "../actions/index";
import * as kApi from "../../constants/api";
import { Auth } from "aws-amplify";
import { refreshTokenSaga } from "./_LocalRefreshToken";

export function* initFetchTasksSaga(action) {
  const userSub =
    action.activeUser && action.activeUser.sub
      ? "/" + action.activeUser.sub
      : "";
  try {
    const response = yield axios.get(kApi.API_Q_TASKS + userSub, {
      headers: {
        Authorization: Auth.user.signInUserSession.idToken.jwtToken,
      },
    });
    if (response.data.tasks)
      yield put(actions.fetchTasksSuccess(response.data.tasks));
    else yield put(actions.fetchTasksSuccess(response.data));
  } catch (error) {
    try {
      const refreshToken = yield refreshTokenSaga();
      const response = yield axios.get(kApi.API_Q_TASKS + userSub, {
        headers: {
          Authorization: refreshToken.signInUserSession.idToken.jwtToken,
        },
      });
      if (response.data.tasks)
        yield put(actions.fetchTasksSuccess(response.data.tasks));
      else yield put(actions.fetchTasksSuccess(response.data));
    } catch (error) {
      yield put(actions.fetchTasksFail(error));
    }
  }
}
